import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, IconButton, Stack, TextField, Tooltip } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send'
import SaveIcon from '@mui/icons-material/Save';
import { useValue } from '../../../context/ContextProvider';
import { EnviarNuevaMarca } from '../../../actions/marcas';

const NuevaMarca = ({ openNuevaMarca, setOpenNuevaMarca, isUpdate, rowOriginal }) => {
    const marcaRef = useRef();
    const descRef = useRef();
    const habRef = useRef();
    const [habCheck, setHabCheck] = useState(true);
    const { state: { currentUser, marcas }, dispatch } = useValue();

    useEffect(() => {
        if(isUpdate) 
            rowOriginal.habilitado==1 ? setHabCheck(true) : setHabCheck(false);
    }, [openNuevaMarca])

    const handleClose = () => {
        setOpenNuevaMarca(false);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const marca = marcaRef.current.value;
            const descripcion = descRef.current.value;
            const id = isUpdate? rowOriginal.id : 0; 
            //const habilitado = isUpdate? habRef.current.value  : true;
            const habilitado = habCheck;
    
            const result = await EnviarNuevaMarca({ isUpdate, id, marca, descripcion, habilitado }, currentUser, dispatch);
            //console.log("Respuesta del servidor: ", result.rows);
            let marcasActualizadas = null;
            let mensaje = null;
            if(isUpdate) {
                //const index = marcas.map(object => object.id).indexOf(result.row[0].id);
                //const index = marcas.findIndex(object => {
                //    return object.id === result.row[0].id;
                //});
                
                //Codigo para actualiza un objeto que está en el array de marcas
                marcasActualizadas = marcas.map(element => element.id == result.rows[0].id ? result.rows[0] : element);
                mensaje = 'Se actualizó la marca con éxito.'
            } else {
                marcasActualizadas = [...marcas, result.rows[0]];
                mensaje = 'Se creo la marca con éxito.'
            }
            //console.log("Tabla marcas actualizada: ", marcasActualizadas);
            dispatch({ type: 'UPDATE_MARCAS', payload: {rows: marcasActualizadas }});
            setOpenNuevaMarca(false);
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: mensaje } });
        } catch (error) {
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: 'Error M010: No se pudo crear la marca. Compruebe su conexión.' } });
        }
    }





    return (
        <Dialog
            open={openNuevaMarca}
            onClose={handleClose}
        >
            <DialogTitle>
                {isUpdate? 'Editar Marca' : 'Nueva Marca'}
                <IconButton
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    onClick={handleClose}
                >
                    <CancelIcon />
                </IconButton>
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent dividers>
                    <DialogContentText>
                    {isUpdate? 'Puede editar los siguientes campos:' : 'Por favor llene los siguientes campos:'}
                    </DialogContentText>


                    <TextField
                        autoFocus
                        margin='normal'
                        variant='outlined'
                        id='marca'
                        label='Marca'
                        type='text'
                        fullWidth
                        inputRef={marcaRef}
                        inputProps={{ minLength: 2 }}
                        required
                        defaultValue={isUpdate? rowOriginal?.marca : ''}
                        helperText='Nombre de la marca'
                    />


                    <TextField
                        margin='normal'
                        variant='outlined'
                        id='desc'
                        type='text'
                        label='Descripcion'
                        fullWidth
                        inputRef={descRef}
                        inputProps={{ minLength: 6 }}
                        multiline
                        rows={2}
                        defaultValue={isUpdate? rowOriginal?.descripcion : ''}
                        required
                    />
                    
                    {isUpdate && <FormControlLabel control={
                        <Checkbox 
                            checked={habCheck} 
                            inputRef={habRef}
                            onChange={() => setHabCheck(!habCheck)}
                        />
                    } label="Registro habilitado" />}

                </DialogContent>
                <DialogActions sx={{ pr: '22px', pt: '20px' }}>
                    <Button onClick={handleClose} variant="outlined" startIcon={<CancelIcon />}>
                        Cancelar
                    </Button>
                    <Button type='submit' variant='contained' startIcon={<SaveIcon />}>
                        Guardar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>

    )
}

export default NuevaMarca